import 'select2';
import 'select2/dist/css/select2';
import { Controller } from "stimulus"
import AjaxLoader from '../entrypoints/src/admin/utilities/ajax-loader';

export default class extends Controller {
  static targets = [
    'form',
    'btnPickSchedule',
  ];
  static values = {
    'uid': String,
    'selectedSchedules': Array,
    'oste': Boolean,
    'price': String,
    'service': String
  };

  disconnect() {
    AjaxLoader.hide();
  }

  connect() {
    AjaxLoader.hide();
    $(this.element.querySelector('.select2.batch')).select2({
      placeholder: '-- selecione --',
      multiple: false,
      allowClear: false,
      width: 'resolve',
      escapeMarkup: (markup) => markup,
      dropdownParent: this.element.closest('.modal')
    });

    if (this.hasBtnPickScheduleTarget) {
      this.btnPickScheduleTarget.addEventListener('click', (ev) => this.openPickSchedule());
    }
  }

  async openPickSchedule() {
    await this.element.querySelector('turbo-frame.schedule-calendar').loaded

    let modal = this.element.querySelector('.schedule-board-modal'),
      $el = modal.querySelector('.modal-body'),
      form = $el.querySelector('.calendar-form'),
      set = new Set(this.selectedSchedulesValue.map((it) => it.level_id));

    form.insertAdjacentHTML('beforeEnd', `
      <input type="hidden" name="keep_selection" value="true" />
      <input type="hidden" name="service_id" value="${this.serviceValue}" />
      <input type="hidden" name="price_id" value="${this.priceValue}" />
      <input type="hidden" name="object_name" value="${this.element.dataset.schedulesObjectName}" />
      <input type="hidden" name="selected_schedules" value='${JSON.stringify(this.selectedSchedulesValue)}' />
      ${set.size == 1 ? `<input type="hidden" name="level_id" value="${set.keys().next().value}" />` : ''}
      <button class="hidden" id="submit-form-programmatically"></button>
    `);
    form.querySelector('#submit-form-programmatically').click();

    $(modal).modal('show');
  }

  saveSchedules(ev) {
    this.formTarget.querySelector('.contract-schedules').innerHTML = [...document.querySelectorAll('.schedule-board-modal .card.selected-schedule, .schedule-board-modal .card.selected-batch-schedule')].map(
      ($el) => [...$el.querySelectorAll('.object-values')]
    ).flat().map((node) => node.outerHTML).join('');

    this.formTarget.insertAdjacentHTML('beforeend', '<input type="hidden" name="updated-schedules" value="on" />');

    this.submitForm(ev);
  }

  async submitForm(ev) {
      // let $target = ev.currentTarget;

      // if (this.hasSelectPriceTarget)
      //   this.updatePriceBatchCompositionRef();

      $(this.element.querySelector('.schedule-board-modal')).modal('hide');
      this.formTarget.insertAdjacentHTML('beforeend', '<button class="hidden" id="formSubmissionTrigger">submit</button>');
      this.formTarget.insertAdjacentHTML('beforeend', '<input type="hidden" value="on" name="editing" />');
      AjaxLoader.show();
      setTimeout(() => this.element.querySelector('#formSubmissionTrigger').click());
    }
}
